import type { BookingPageMetaTitles } from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

export const pageMetaTitlesFallback: BookingPageMetaTitles = {
  internalName: '',
  landingPage: '',
  sessionsListingPage: '',
  sessionDetails: '',
  sceneSelection: '',
  addOnsSelection: '',
  scheduleSession: '',
  checkoutSummary: '',
  checkoutPrePay: '',
  checkoutTerms: '',
  checkoutPay: '',
  orderCompleteStripe: '',
  confirmation: '',
  notFound: ''
}
